//things that make the interface cool
import * as $ from 'jquery';

export default (function () {

  $('#customSwitchExample2').on('change', function(){
      var checked = $(this).is(':checked');
      if(checked){ //pro annual
          $('.year-label').show();
          $('.month-label').hide();
          $('.pricing-card-lite').attr('data-cadence', 'annual');
      } else { //pro monthly
          $('.year-label').hide();
          $('.month-label').show();
          $('.pricing-card-lite').attr('data-cadence', 'monthly');
      }
      // if($('.pricing-card-pro').is('.active')){
        $('.pricing-card.active').trigger('click');
      // }
  }).trigger('change');

  // var existingPlan = $('input#user_plan').val();
  // console.log(existingPlan);
  // if(existingPlan == 'monthly'){
  //   $('#customSwitchExample2').attr('checked', false);
  //   $('.pricing-card-pro').data('plan', 'pro-monthly').trigger('click');
  // } else if (existingPlan == 'annual') {
  //   $('.pricing-card-pro').trigger('click');
  // } else if (existingPlan == 'basic') {
  // console.log('y');
  //   $('.pricing-card-basic').trigger('click');
  // }

  var plan = $('#subscribe-form input[type=radio][name=plan]:checked').val();


  $('.pricing-card').on('click', function(){
      $('.pricing-card').removeClass('active');
      $(this).addClass('active');
      var level = $(this).attr('data-plan');
      var cadence = $(this).attr('data-cadence');
      var planToCheck = level + '-' + cadence;
      console.log(planToCheck);
      // var selectedPlan = $(this).data('plan');
      $('.level-display-field').hide();
      $(`.${planToCheck}-display`).show();
      $(`input#${planToCheck}`).prop("checked", true);
      // cardVisibilityChecker();
  });

  $('.pricing-card.active').trigger('click');


  // if(plan == 'pro-annual'){
  //   $('.pricing-card-pro').trigger('click');
  // } else if (plan == 'pro-monthly') {
  //   $('#customSwitchExample2').attr('checked', false);
  //   $('.pricing-card-pro').trigger('click');
  // } else if (plan == 'basic') {
  //   $('.pricing-card-basic').trigger('click');
  //   $('#customSwitchExample2').attr('checked', false);
  // }
  // cardVisibilityChecker();

  $('a.toggle-link').on('click', function(e){
    e.preventDefault();
    var el = $(this).attr('href');
    $(el).toggle();
  });

  //handle plan logic
  // $('#subscribe-form input[type=radio][name=plan]').change(function() {
  //   plan = this.value;
  //   cardVisibilityChecker();
  // });

  const form = document.getElementById( 'subscribe-form' );

  if(form){
  const elements = stripe.elements();
  // const cardElement = elements.create('card');
  const cardHolderName = document.getElementById('first_name');
  const cardButton = document.getElementById('card-button');
  const clientSecret = cardButton.dataset.secret;
  // cardElement.mount('#card-element');

  //new

  let style = {
    base: {
      color: '#32325d',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      'fontSize': '16px',
      '::placeholder': {
        color: '#aab7c4'
      },
      ':-webkit-autofill': {
        color: '#32325d',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
      ':-webkit-autofill': {
        color: '#fa755a',
      },
    }
  };

  // let card = elements.create("card", { style: style });
  // card.mount("#card-element");
  //
  var cardNumber = elements.create('cardNumber', { style: style });
  cardNumber.mount('#example2-card-number');
  var cardExpiry = elements.create('cardExpiry', { style: style });
  cardExpiry.mount('#example2-card-expiry');
  var cardCvc = elements.create('cardCvc', { style: style });
  cardCvc.mount('#example2-card-cvc');
  //end new

  form.addEventListener( 'submit', (e) => {
    if(plan=="pro-annual" || plan=="pro-monthly"){
      e.preventDefault();
    };
    // } else {
    //   gtag('event', 'conversion', {
    //       'send_to': 'AW-337967647/JZfvCL_Bt9MCEJ_0k6EB',
    //       'value': 0,
    //       'currency': 'USD'
    //   });
    // }
  });

  //listen for errors
  cardNumber.addEventListener('change', function(event) {
    var displayError = document.getElementById('card-errors');
    if (event.error && (plan=="pro-annual" || plan=="pro-monthly")) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = '';
    }
  });

    cardButton.addEventListener( 'click', async (e) => {
      if(plan=="pro-annual" || plan=="pro-monthly"){
        const { setupIntent, error } = await stripe.handleCardSetup(
          clientSecret, cardNumber, {
            payment_method_data: {
              billing_details: { name: cardHolderName.value }
            }
          }
        );

        if (error) {
          // Display "error.message" to the user...
        } else {
          // The card has been verified successfully...
          startButtonLoading($('#card-button'));
            // gtag('event', 'conversion', {
            //     'send_to': 'AW-337967647/JZfvCL_Bt9MCEJ_0k6EB',
            //     'value': 149.00,
            //     'currency': 'USD'
            // });
          handleStripePayment( setupIntent );
        }
      }
    });

  let handleStripePayment = setupIntent => {
    let paymentInput = document.createElement( 'input' );
    paymentInput.setAttribute( 'name', 'stripePaymentMethod' );
    paymentInput.setAttribute( 'type', 'hidden' );
    paymentInput.setAttribute( 'value', setupIntent.payment_method );
    form.appendChild( paymentInput );

    form.submit();
  }
  }

  //check to see what plan we're on and hide/show the apropos div
  // function cardVisibilityChecker(){
  //   plan = $('#subscribe-form input[type=radio][name=plan]:checked').val();

  //   if(plan=="pro-annual" || plan=="pro-monthly"){
  //     $('.plan-billable').show();
  //   } else {
  //     $('.plan-billable').hide();
  //   }

  // }

  function startButtonLoading(el){
      el.disabled = true;
      el.append('<span class="spinner-border mx-2 spinner-border-sm" role="status" aria-hidden="true"></span>');
  }

}());


